import qs from 'qs'
import axios from 'axios'

axios.defaults.baseURL = 'http://itineraryapi.yl969.com'
// axios.defaults.headers.common['Request-Preview'] = new URLSearchParams(window.location.search).get('preview') || 0

function requestGet(path, params) {
  return new Promise((resolve, reject) => {
    axios.get(path, {
      params: params || {}
    }).then(res => {
      if (res.data.code === 0) {
        resolve(res.data)
      } else {
        console.log(res.data);
        reject(res)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

function requestPost(path, params) {
  return new Promise((resolve, reject) => {
    axios.post(path, qs.stringify(params)).then(res => {
      // if (res.data.code === 0) {
        resolve(res.data)
      // } else {
      //   reject(res)
      // }
    }).catch(err => {
      reject(err)
    })
  })
}

export default {
  requestGet,
  requestPost
}